import { render, staticRenderFns } from "./DashboardTotalList.vue?vue&type=template&id=18ef5228&scoped=true&"
import script from "./DashboardTotalList.vue?vue&type=script&lang=js&"
export * from "./DashboardTotalList.vue?vue&type=script&lang=js&"
import style0 from "./DashboardTotalList.vue?vue&type=style&index=0&id=18ef5228&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ef5228",
  null
  
)

export default component.exports